import { connect, useDispatch } from 'react-redux';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { Link } from 'foundations-components/transitional/components/Link';
import { getInboxSettingsUrl } from '../../routing/utils/externalUrls';
import debounce from 'react-utils/debounce';
import { getConnectedForms } from '../../actions/ConnectedFormsActions';
import { formHasTicketFieldObjectType } from '../../reducers/connectedForms';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const parseOptions = rawForms => [...rawForms.map(form => {
  return {
    text: form.name,
    value: form.guid
  };
})];
const SupportFormIdField = ({
  onFieldChange,
  connectedForms,
  readOnly,
  value: supportFormId
}) => {
  const dispatch = useDispatch();
  const handleSupportFormSelectChange = ({
    target: {
      value
    }
  }) => {
    onFieldChange(value);
  };
  const supportFormEnabled = supportFormId !== null;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.templateEditor.fields.supportFormSetting.label"
        }),
        tooltip: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "knowledgeContentUI.templateEditor.fields.supportFormSetting.formSelectTooltip_jsx",
          elements: {
            UILink: Link
          },
          options: {
            href: 'https://knowledge.hubspot.com/inbox/connect-channels-to-the-conversations-inbox',
            external: true
          }
        }),
        tooltipPlacement: "left",
        marginBlockStart: "300",
        children: /*#__PURE__*/_jsx(Select, {
          autoload: false,
          disabled: readOnly,
          cache: false,
          clearable: true,
          "data-testid": "support-form",
          placeholder: I18n.text('knowledgeContentUI.templateEditor.fields.supportFormSetting.emptyState'),
          noResultsText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.templateEditor.fields.supportFormSetting.noResults"
          }),
          onChange: handleSupportFormSelectChange,
          loadOptions: debounce((searchString, callback) => {
            return dispatch(getConnectedForms(searchString)).then(formsResponse => {
              callback(null, {
                options: parseOptions(formsResponse.payload.filter(formHasTicketFieldObjectType))
              });
            }, err => callback(err));
          }, 200),
          options: parseOptions(connectedForms),
          value: supportFormEnabled ? supportFormId : null
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "200",
        marginBlockStart: "100",
        as: "div",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "knowledgeContentUI.templateEditor.fields.supportFormSetting.descriptionCreateOrEditForm_jsx",
          elements: {
            Link: ({
              children
            }) => /*#__PURE__*/_jsx(Link, {
              external: true,
              href: getInboxSettingsUrl(),
              children: children
            })
          }
        })
      })]
    })
  });
};
const mapStateToProps = ({
  connectedForms
}) => {
  return {
    connectedForms
  };
};
export default connect(mapStateToProps, null)(SupportFormIdField);